import InfoCard from "@/common/cards/InfoCard";
import { Row } from "@/common/custom-lists/ListView";
import Tooltip from "@/tooltip";
import { BuildingOffice2Icon } from "@/icons/solid";
import { connect } from "react-redux";
import { Actions as AUTHENTICATION_ACTIONS } from "../../store/actions/authenticationActions";

const ClientRow = ({ client, switchCompany, view }) => {
	if (view === "Card")
		return (
			<InfoCard
				header={
					<div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)" }}>
						<div style={{ display: "flex", gridColumn: "1 / span 2" }}>
							<h4 style={{ marginLeft: "1rem" }}>{client?.name}</h4>
						</div>
					</div>
				}
				footer={
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						<div className="btn-group">
							<a
								to={`/advisor/team`}
								className="btn btn-xs btn-primary mr-3"
								type="button"
								onClick={(e) => {
									switchCompany(client?.id, `/people`);
								}}
							>
								<BuildingOffice2Icon className="w-6 h-6 media-middle" />
								Switch
							</a>
						</div>
					</div>
				}
			/>
		);

	return (
		<Row
			actionColumns={[0]}
			columns={[
				" ",
				client?.name,
				client?.status,
				<div className="btn-group">
					<Tooltip
						content={`Switch to ${client?.name}`}
						arrowSize={4}
					>
						<a
							to={`/advisor/team`}
							className="btn btn-xs btn-primary mr-3"
							type="button"
							onClick={(e) => {
								switchCompany(client?.id, `/people`);
							}}
						>
							<BuildingOffice2Icon className="w-6 h-6 media-middle" />
						</a>
					</Tooltip>
				</div>,
			]}
		/>
	);
};

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({
	switchCompany: (companyId, link) => dispatch(AUTHENTICATION_ACTIONS.switchCompany(companyId, link)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientRow);
